import { apiMhn, apiLocal } from '@/services/Api'

function parse (objId, end, project) {
  return apiLocal().get(`parse/parsemhn?objId=${objId}&end=${end}&project=${project}`)
}

function getSpoList (limit, skip, keys) {
  return apiMhn().get(`classes/RingSport`, {
    params: {
      where: {deleted: {$ne: true}},
      order: '-updatedAt',
      limit: limit || null,
      skip: skip || 0,
      keys: keys || 'objectId,startAt,avgO2,avgPr,remoteDevice,updatedAt,createdAt,userInfoPointer.HeadPortiat,userInfoPointer.name',
      include: 'userInfoPointer'
    }
  })
}

function getSpoListCounts () {
  return apiMhn().get(`classes/RingSport`, {
    params: {
      where: {deleted: {$ne: true}},
      limit: 0,
      count: 1
    }
  })
}

function fetchByObjectId (objectId) {
  return apiMhn().get(`classes/RingSport/` + objectId, {
    params: {
      keys: 'objectId,ringData,updatedAt,createdAt'
    }
  })
}

export {
  parse,
  getSpoList,
  getSpoListCounts,
  fetchByObjectId
}



// WEBPACK FOOTER //
// ./src/services/MhnService.js